import { ErrorResponse } from '@gtpl/shared-models/common-models';
// import { LogActions } from '@gtpl/libs/shared-utils/kafka-common-lib'
import { FreebieModel, FreebiesResponse, empDeptRequest } from '@gtpl/shared-models/canteen-management';
import { forwardRef, Inject, Injectable } from '@nestjs/common';
// import mdmConfigs from 'config';
import { MoreThan, LessThanOrEqual, getManager, Repository } from 'typeorm';
// import { EmployeeService } from '../employee/employee.service';
import { FreebieRequest } from './dto/freebie.dto';
// import { FreebieIdRequest } from './dto/freebie.dto';

import { FreebieEntity } from './entity/freebie.entity';
import { FreebiesAdapter } from './freebies.adapter';
import { FreebieRepo } from './repository/freebies.repository';
import { CommonResponse } from '@gtpl/shared-models/production-management';
// import { FreebiesMappingConsumptionService } from '@gtpl/shared-services/canteen-management';
import { FreebieIdRequest } from './dto/freebie-id.request';
import { CompanyIdHoursRequest } from './dto/company-id-hours.request';
// import { Departments } from 'apps/services/masters/src/app/departments/departments.entity';
import appSettings from 'apps/services/config';
import { InjectRepository } from '@nestjs/typeorm';
import { FreebiesMappingConsumptionService } from '@gtpl/shared-services/canteen-management';
@Injectable()
// @LoggerInstantiation(mdmConfigs.loggingMode)
export class FreebiesServices {
    constructor(
        private freebiesRepo: FreebieRepo,
        private freebiesAdapter: FreebiesAdapter,

        private tokensService: FreebiesMappingConsumptionService,

    ) {

    }
    /**
     * creates the freebies
     * @param freebiesReq 
     * @returns 
     */

    async createFreebie(freebiesReq: FreebieRequest): Promise<CommonResponse> {
        try {
            console.log('frebieReq****', freebiesReq)
            freebiesReq.freebieId = null;
            // check if the freebie already exist 
            const freebie = await this.getFreebieByCodeHelper(freebiesReq.freebieCode);
            if (freebie) {
                throw new ErrorResponse(0, 'Freebie Code Already Exists');
            }
            // save the freebies request into the DB
            const freebieEntity = this.freebiesAdapter.convertDtoToFreebieEntity(freebiesReq);
            const savedFreebies = await this.freebiesRepo.save(freebieEntity);
            const freebiesModel = this.freebiesAdapter.convertFreebieEntityToDto(savedFreebies);
            return new CommonResponse(true, 0, 'Freebies saved successfully', [freebiesModel]);
        } catch (err) {
            throw err;
        }
    }

    /**
     * updates the freebies
     * @param freebiesReq 
     * @returns 
     */
    // @LogActions({ isAsync: true })
    async updateFreebie(freebiesReq: FreebieRequest): Promise<FreebiesResponse> {
        // check if the freebie already exist 
        const freebie = await this.getFreebieByIdHelper(freebiesReq.freebieId);
        console.log('$$$$', freebiesReq)
        if (!freebie) {
            throw new ErrorResponse(0, 'Freebie does not exist');
        }
        if (freebie.freebieCode !== freebiesReq.freebieCode) {
            throw new ErrorResponse(0, 'You cannot edit freebie code. Please create a new one by deleting the current one');
        } else {
            const freebieEntity = this.freebiesAdapter.convertDtoToFreebieEntity(freebiesReq);
            console.log(freebieEntity, 'ddddddddddd')
            // update the freebie
            const savedFreebies = await this.freebiesRepo.save(freebieEntity);
            console.log(savedFreebies)
            const freebiesModel = this.freebiesAdapter.convertFreebieEntityToDto(savedFreebies);
            console.log(FreebieModel)
            return new FreebiesResponse(true, 0, 'Freebie updated successfully', [freebiesModel]);
        }
    }

    /**
     * gets the freebie by id
     * @param freebieId 
     * @returns 
     */
    // @LogActions({ isAsync: true })
    async getFreebieById(freebieId: number): Promise<FreebieEntity> {
        const freebie = await this.freebiesRepo.findOne({ where: { freebieId: freebieId } });
        if (freebie) {
            return freebie;
        } else {
            return null;
        }
    }

    /**
     * deletes the freebie by id
     * @param freebieId 
     * @returns 
     */
    // @LogActions({ isAsync: true })
    async deleteFreebieById(freebieId: number, username: string): Promise<FreebiesResponse> {
        // check if the freebie exist 
        const freebie = await this.freebiesRepo.findOne({ where: { freebieId: freebieId, isActive: true } });
        if (!freebie) {
            throw new ErrorResponse(0, 'Freebie does not exist');
        }
        const freebiedIdReq = new FreebieIdRequest();
        freebiedIdReq.freebieId = freebieId;
        const validateEmployee = await this.tokensService.checkEmployeewithfrbId(freebiedIdReq);
        if (validateEmployee) {
            return new FreebiesResponse(false, 1, "Cannot delete Freebies, employee is activated for this freebie");
        }
        else {
            await this.freebiesRepo.update({ freebieId: freebieId }, { isActive: false, updatedUser: username });
            return new FreebiesResponse(true, 0, 'Freebies deleted successfully', []);
        }

    }

    /**
     * 
     * @param freebieId 
     * @returns 
     */
    // @LogActions({ isAsync: true })
    async getFreebieByIdHelper(freebieId: number): Promise<FreebieEntity> {
        return await this.freebiesRepo.findOne({ where: { freebieId: freebieId } });
    }

    /**
     * 
     * @param freebieCode 
     * @returns 
     */
    // @LogActions({ isAsync: true })
    async getFreebieByCodeHelper(freebieCode: string): Promise<FreebieEntity> {
        return await this.freebiesRepo.findOne({ where: { freebieCode: freebieCode } });
    }

    /**
     * gets the freebies defined for a company
     * @param companyId 
     */
    // @LogActions({ isAsync: true })
    async getFreebiesByCompanyId(companyId: number): Promise<FreebiesResponse> {
        const freebieModels: FreebieModel[] = [];
        const freebies = await this.freebiesRepo.find({ where: { companyId: companyId } });
        for (const freebie of freebies) {
            freebieModels.push(this.freebiesAdapter.convertFreebieEntityToDto(freebie));
        }
        return new FreebiesResponse(true, 0, 'Freebies retrieved successfully', freebieModels);
    }

    /**
     * gets all the freebies
     */
    // @LogActions({ isAsync: true })
    // async getAllFreebies(): Promise<FreebiesResponse> {
    //     const freebieModels: FreebieModel[] = [];
    //     const freebies = await this.freebiesRepo.find({ isActive: true });
    //     // const deprtdata = await this.deprtrepo.findOne({deptId:})
    //     for (const freebie of freebies) {
    //        const freebieData = this.freebiesAdapter.convertFreebieEntityToDto(freebie)
    //         freebieModels.push(freebieData);
    //     }
    //     console.log('----freebies data---',freebieModels)
    //     return new FreebiesResponse(true, 0, 'Freebies retrieved successfully', freebieModels);
    // }

    async getAllFreebies(): Promise<FreebiesResponse> {
        try {
            const manager = getManager();

            const query = ' SELECT d.dept_name AS deptName,freebie_id AS freebieId,freebie_code AS freebieCode, category as freebieCategory,unit_price AS unitPrice,description,start_hour AS startHour,start_minutes AS startMinutes,end_hour AS endHour,end_minutes AS endMinutes,department_id AS departmentId,company_id AS companyId,job_hour AS jobHour,f.is_active AS isActive,f.created_user AS createdUser,f.created_at AS createdAt,f.updated_user AS updatedUser,f.updated_at AS updatedAt,CONCAT(start_hour,":",start_minutes) AS startTiming,CONCAT(end_hour,":",end_minutes) AS endTiming,f.version_flag AS versionFlag FROM `erpx_dev_cms`.`freebie` f LEFT JOIN `erpx_dev_masters`.`departments` d ON f.department_id=d.dept_id'
            const result = await manager.query(query)
            if (result) {
                return new FreebiesResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new FreebiesResponse(false, 1111, "Error occure")

            }
        }
        catch (err) {
            return err;
        }

    }

    async getReportData(req?: empDeptRequest): Promise<FreebiesResponse> {
        try {
            const manager = getManager();
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth() + 1;
            console.log('----------------',currentYear,currentMonth)
            let query = ' SELECT ef.original_count AS originalCount , ef.available_count AS availableCount , e.employee_code,CONCAT(e.employee_name," ",e.emp_last_name)AS empName, ef.employee_id ,f.freebie_code AS freebieCode, f.category AS freebieCategory,f.unit_price AS unitPrice,f.description, f.start_hour AS startHour, f.start_minutes AS startMinutes,f.end_hour AS endHour,f.end_minutes AS endMinutes,CONCAT(end_hour,":",end_minutes) AS endTiming, CONCAT(start_hour,":",start_minutes) AS startTiming,f.company_id AS companyId FROM `erpx_dev_cms`.`employee_freebies` ef  LEFT JOIN `erpx_dev_cms`.`freebie` f ON f.freebie_id = ef.freebie_id  LEFT JOIN `erpx_dev_masters`.`employee_details` e ON e.employee_id = ef.employee_id WHERE ef.year ='+currentYear + ' AND ef.month = ' + currentMonth 
            console.log(req.employeeId)
            if (req.employeeId) {
                query = query + ' AND ef.employee_id= ' + req.employeeId
            }
            const result = await manager.query(query)
            if (result) {
                return new FreebiesResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new FreebiesResponse(false, 1111, "Error occure")

            }
        }
        catch (err) {
            return err;
        }

    }
    /**
     * gets the proper freebie mapped for a given hour 
     * @param companyIdHourReq 
     */
    // @LogActions({ isAsync: true })
    async getFreebieForCompanyAndHours(companyIdHourReq: CompanyIdHoursRequest): Promise<FreebiesResponse> {
        const freebie = await this.freebiesRepo.findOne({
            where: {
                companyId: companyIdHourReq.companyId,
                endHour: MoreThan(companyIdHourReq.currentHour), startHour: LessThanOrEqual(companyIdHourReq.currentHour),
                isActive: true,
            }
        });
        if (!freebie) {
            throw new ErrorResponse(0, 'No freebie is allotted for the current hour');
        }
        const freebieModel = this.freebiesAdapter.convertFreebieEntityToDto(freebie);
        return new FreebiesResponse(true, 0, 'Freebies retrieved successfully', [freebieModel]);
    }

    /**
     * gets the freebies for the given hour
     * @param companyIdHourReq 
     * @returns 
     */
    // @LogActions({ isAsync: true })
    async getFreebieForCurrentJobHour(companyIdHourReq: CompanyIdHoursRequest): Promise<FreebiesResponse> {
        const freebieModels: FreebieModel[] = [];
        const freebies = await this.freebiesRepo.find({
            where: {
                jobHour: companyIdHourReq.currentHour,
                isActive: true,
            }
        });
        if (!freebies.length) {
            throw new ErrorResponse(0, 'No freebie for the current hour')
        }
        for (const freebie of freebies) {
            freebieModels.push(this.freebiesAdapter.convertFreebieEntityToDto(freebie));
        }
        return new FreebiesResponse(true, 0, 'Freebies retrieved successfully', freebieModels);
    }


    // @LogActions({ isAsync: true })
    // async getAllFreebiesDropdown(): Promise<FreebiesResponse> {
    //     const freebieModels: FreebieModel[] = [];
    //     const freebies = await this.freebiesRepo.find({ select: ['freebieCode', 'freebieId'], where: { isActive: true } });
    //     for (const freebie of freebies) {
    //         freebieModels.push(this.freebiesAdapter.convertFreebieEntityToDto(freebie));
    //     }
    //     return new FreebiesResponse(true, 0, 'Freebies retrieved successfully', freebieModels);
    // }

    // async getAllActiveFreebies(): Promise<FreebiesResponse> {
    //     try {
    //         const FreebieRequestDTO: FreebieRequest[] = [];
    //         const FreebieEntities: FreebieEntity[] = await this.freebiesRepo.find({
    //             order: { createdAt: 'DESC' }, where: { isActive: true }
    //         });
    //         console.log(FreebieEntities)
    //         if (FreebieEntities) {
    //             FreebieEntities.forEach(freebieEntity => {
    //                 const convertedFreebiesDTO: FreebieRequest = this.freebiesAdapter.convertFreebieEntityToDto(
    //                     freebieEntity
    //                 );
    //                 FreebieRequestDTO.push(convertedFreebiesDTO);
    //             });
    //             const response = new FreebiesResponse(true, 11108, "Freebiess retrieved successfully", FreebieRequestDTO);
    //             return response;
    //         } else {
    //             throw new ErrorResponse(99998, 'Data not found');
    //         }
    //     }
    //     catch (err) {
    //         return err;
    //     }
    // }

    async getAllActiveFreebies(): Promise<FreebiesResponse> {
        try {
            const manager = getManager();
            const query = 'SELECT freebie_id AS freebieId,freebie_code AS freebieCode FROM `erpx_dev_cms`.`freebie` WHERE is_active=1';
            const result = await manager.query(query)
            if (result) {
                return new FreebiesResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new FreebiesResponse(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }

    }
    async ActivateorDeactivateFreebies(freebiesReq: FreebieIdRequest): Promise<FreebiesResponse> {
        try {
            const freebieExists = await this.getFreebieById(freebiesReq.freebieId);
            if (freebieExists) {
                if (freebiesReq.versionFlag !== freebieExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Freebies information.Refresh and try again');
                } else {
                    const departmentStatus = await this.freebiesRepo.update(
                        { freebieId: freebiesReq.freebieId },
                        { isActive: freebiesReq.isActive, updatedUser: freebiesReq.updatedUser });

                    if (freebieExists.isActive) {
                        if (departmentStatus.affected) {
                            const departmentResponse: FreebiesResponse = new FreebiesResponse(true, 10115, 'Freebies is de-activated successfully');
                            return departmentResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Freebies is already deactivated');
                        }
                    } else {
                        if (departmentStatus.affected) {
                            const departmentResponse: FreebiesResponse = new FreebiesResponse(true, 10114, 'Freebies is activated successfully');
                            return departmentResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Freebies is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
}
